import styled from 'styled-components';

const LargeCol =  styled.div`
	padding: 0 25px;
	max-width: 100%;
	flex-basis: 100%;

	@media (min-width: 1024px) {
		max-width: ${( 7.5/12 ) * 100}%;
		flex-basis: ${( 7.5/12 ) * 100}%;
	}

	@media (min-width: 1200px) {
		max-width: ${( 8/12 ) * 100}%;
		flex-basis: ${( 8/12 ) * 100}%;
	}
`;

export default LargeCol;
